/** @jsxRuntime classic */
import React from "react";
import { useParams } from "react-router";

import { View } from "./View";
import { useThis } from "./useThis";

import type { PATH_PARAMETERS } from "constants/pathParameters";
import type { FC } from "react";
import type { GetParameters } from "types/GetParameters";

type Params = GetParameters<
  [(typeof PATH_PARAMETERS)["/account/settlement/history/:orderId"]]
>;

export const AccountSettlementHistoryOrderId: FC = () => {
  const parameters = useParams<Params>();
  const props = useThis({ parameters });

  return <View {...props} />;
};
